import { DifficultyLevel } from '@/data/mock-data';
import { Mountain, TrendingUp, Award } from 'lucide-react';

interface DifficultyBadgeProps {
  difficulty: DifficultyLevel;
  className?: string;
}

export function DifficultyBadge({ difficulty, className = '' }: DifficultyBadgeProps) {
  const config = {
    Beginner: {
      color: 'bg-emerald-100 text-emerald-700 border-emerald-300',
      icon: Mountain,
      label: 'Beginner',
    },
    Intermediate: {
      color: 'bg-amber-100 text-amber-700 border-amber-300',
      icon: TrendingUp,
      label: 'Intermediate',
    },
    Advanced: {
      color: 'bg-rose-100 text-rose-700 border-rose-300',
      icon: Award,
      label: 'Advanced',
    },
  };

  const { color, icon: Icon, label } = config[difficulty];

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium border ${color} ${className}`}
    >
      <Icon className="w-4 h-4" />
      {label}
    </span>
  );
}
